import { Labeled, LabeledProps } from '@infotech-soe/erp-ui-kit';
import React, { FC } from 'react';

type Props = Pick<LabeledProps, 'children' | 'label'>;

const LoginFormField: FC<Props> = ({ label, children }) => (
  <Labeled
    className="m-pb-lg"
    labelVerticalAlign="center"
    label={label}
    childColumns={8}
  >
    {children}
  </Labeled>
);

export default LoginFormField;
